import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IPreviewClipTitleV1Response } from './preview-clip-title-v1-response';
import { previewClipTitleV1ResponseSchema } from './preview-clip-title-v1-response';

export async function previewClipTitleV1Api(
  clipId: number,
  title: string,
): Promise<IValidatedResponse<IPreviewClipTitleV1Response>> {
  return postRequest<IPreviewClipTitleV1Response>({
    path: `/sys/clips/${clipId}/title/preview/v1`,
    body: { title },
    schema: previewClipTitleV1ResponseSchema,
  });
}
